module.exports = __webpack_public_path__ + "static/img/index_bg.f311055.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_bg.jpg
// module id = hgoJ
// module chunks = 239